"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "言語コード(ISO 639-1)",
                propertyName: "langId",
                schema: {
                    schemaType: "text",
                },
            },
            {
                title: "言語名",
                propertyName: "langName",
                schema: {
                    schemaType: "text",
                },
            },
        ],
    };
};
